import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

function getDefaultRoute(user) {
  if (!user) return '/login';
  if (user.role === 'admin') return '/admin';
  if (user.role === 'partner') return '/dashboard';
  // Internal users - route based on activeRole or first available
  if (user.role === 'internal') {
    const active = user.activeRole;
    if (active === 'marketing' && user.isMarketing) return '/marketing';
    if (active === 'sales' && user.isSales) return '/sales';
    if (active === 'partner_manager' && user.isPartnerManager) return '/pm';
    // Fallback to first available role
    if (user.isMarketing) return '/marketing';
    if (user.isSales) return '/sales';
    if (user.isPartnerManager) return '/pm';
  }
  // Legacy single-role users
  if (user.role === 'marketing') return '/marketing';
  if (user.role === 'sales') return '/sales';
  return '/login';
}

function hasAccess(user, requiredRole) {
  if (!user || !requiredRole) return true;
  if (user.role === requiredRole) return true;
  if (user.role === 'internal') {
    if (requiredRole === 'marketing' && user.isMarketing) return true;
    if (requiredRole === 'sales' && user.isSales) return true;
    if (requiredRole === 'partner_manager' && user.isPartnerManager) return true;
  }
  return false;
}

export default function ProtectedRoute({ children, requiredRole }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-v2-blue"></div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" />;
  if (requiredRole && !hasAccess(user, requiredRole)) {
    return <Navigate to={getDefaultRoute(user)} />;
  }

  return children;
}
